import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import register from '../components/Register.vue'
import retrieve from '../components/Retrieve.vue'
import memberinfo from '../views/MemberInfo.vue'
import memberedit from '../views/MemberEdit.vue'
import main from '../views/Main.vue'
import pay from '../views/Pay.vue'
import help from '../views/Help.vue'
import resource from '../views/Resource.vue'
import Pharma from '../views/Pharma.vue'
import query from '../views/query.vue'
import pdf from '../views/pdf.vue'
import message from '../views/message.vue'
import repair from '../views/Repair.vue'
import page from '../views/Page.vue'
import resetpwd from '../components/ResetPassword.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: register
  },
  {
    path: '/retrieve',
    name: 'retrieve',
    component: retrieve
  }
  ,
  {
    path: '/memberinfo',
    name: 'memberinfo',
    component: memberinfo
  }
  ,
  {
    path: '/memberedit',
    name: 'memberedit',
    component: memberedit
  }
  ,
  {
    path: '/main',
    name: 'main',
    component: main
  }
  ,
  {
    path: '/pay',
    name: 'pay',
    component: pay
  }
  ,
  {
    path: '/help',
    name: 'help',
    component: help
  }
  ,
  {
    path: '/resource/',
    name: 'resource',
    component: resource
  }
  ,
  {
    path: '/repair/',
    name: 'repair',
    component: repair
  }
  ,
  {
    path: '/resetpwd',
    name: 'resetpwd',
    component: resetpwd
  },
  {
    path: '/pharma',
    name: 'pharma',
    component: Pharma
  },
  {
    path: '/query',
    name: 'query',
    component: query
  },
  {
    path: '/pdf/:dcode*',
    name: 'pdf',
    component: pdf
  },
  {
    path: '/message/:mess',
    name: 'message',
    component: message
  },
  {
    path: '/:page',
    name: 'page',
    component: page
  },
  {
		path: '*',
		component: 404,
	}
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
